import StageChange from "Components/StageChange/StageChange";
import { Separator } from "Components/ui/separator";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import key from "../../../Assets/Images/key.svg";
import CredentialsPopup from "./CredentialsPopup";
import { SocketIo } from "App";
import { Skeleton } from "Components/ui/skeleton";
import ChallengeTabs from "Components/ChallengeTabs/ChallengeTabs";
import UseInnerWidth from "hooks/UseInnerWidth";
import MT5Credentials from "./MT5Credentials";
import mt5Icon from "../../../Assets/Images/mt5icon.svg";
import tradelockerIcon from "../../../Assets/Images/tradelockerIcon.svg";
import TradeLockerBlack from "../../../Assets/Images/TradeLockerBlack.svg";
import { useTheme } from "hooks/ThemeContext";

function Header() {
  const { theme } = useTheme();
  const params = useParams();
  const dispatch = useDispatch();
  const width = UseInnerWidth();
  const [open, setOpen] = useState(false);
  const [pl, setPl] = useState(0);
  const { challengeStageInfo, challengeCurrency, challengeStageInfoLoading } =
    useSelector((state) => state.ChallengeOverviewReducer);

  useEffect(() => {
    if (challengeStageInfo?.Account?.login) {
      SocketIo.on(
        "onPositionDelete_" + challengeStageInfo?.Account?.login,
        (data) => {
          setPl(parseFloat((pl || 0) + (data.Profit || 0)));
        }
      );
    }
  }, [challengeStageInfo]);
  return (
    <div className="w-full">
      <div className="flex flex-col gap-4">
        <div className="flex sm:items-center gap-2 justify-between w-full flex-row  items-start">
          <div className="flex items-baseline gap-3 w-fit text-nowrap">
            <div className="text-2xl font-N_Medium flex flex-row gap-4 item-center">
              {!challengeStageInfoLoading &&
                (challengeStageInfo?.Challenge?.Platform?.name?.toLowerCase() ===
                "platform 5" ? (
                  <img src={mt5Icon} alt="mt5" className="w-[3.5rem]" />
                ) : (
                  <img
                    src={theme === "light" ? TradeLockerBlack : tradelockerIcon}
                    alt="tradelockerIcon"
                    className="w-[4.5rem]"
                  />
                ))}
              Challenge {!challengeStageInfoLoading && "-"}{" "}
              {challengeStageInfo?.Account?.login}{" "}
            </div>
          </div>
          <div className="flex items-center gap-4 justify-end w-full">
            {challengeStageInfo?.status == "ACTIVE" && (
              <div
                className="flex items-center gap-2 bg-primary-foreground text-primary text-base py-2 sm:px-6 px-3 rounded-lg cursor-pointer 
          sm:self-auto
          self-end"
                onClick={() => setOpen(true)}
              >
                <img src={key} alt="key" className="w-4 h-auto" />
                {<div className="sm:block hidden"> Credentials</div>}
              </div>
            )}
          </div>
        </div>
        {challengeStageInfoLoading ? (
          <Skeleton className="w-[200px] h-[30px] md:hidden block " />
        ) : (
          width < 950 && (
            <div className="md:hidden block my-4 ">
              <StageChange />
            </div>
          )
        )}
        <ChallengeTabs page="overview" />
      </div>

      <div className="mt-6 rounded-lg flex md:items-center items-start justify-between flex-col md:flex-row 2xl:gap-8 gap-4">
        {challengeStageInfoLoading ? (
          <Skeleton className="w-[255px] h-[80px] md:flex hidden" />
        ) : (
          <div className="bg-background  p-4 2xl:px-6 rounded-lg  items-end mid:w-fit md:w-[25%] w-full 2xl:gap-8 sm:gap-2 justify-center md:justify-start md:flex hidden  border-2 border-border-darkNew ">
            {width > 950 && (
              <div className="flex flex-col gap-1">
                <span className="text-xs text-white-opacity font-N_Roman">
                  Current Stage
                </span>
                <StageChange variant="secondary" />
              </div>
            )}
            <div className="flex flex-col gap-1">
              <div
                className="text-sm font-G_Bold flex items-center gap-2 text-primary py-1 xl:px-6 px-4 rounded-full"
                style={{
                  color:
                    challengeStageInfo?.status == "ACTIVE"
                      ? "var(--green)"
                      : challengeStageInfo?.status == "PASSED"
                      ? "var(--blue)"
                      : challengeStageInfo?.status == "BREACHED"
                      ? "var(--red)"
                      : challengeStageInfo?.status == "PENDING"
                      ? "var(--yellow)"
                      : "var(--white)",
                  backgroundColor:
                    challengeStageInfo?.status == "ACTIVE"
                      ? "var(--green-opacity)"
                      : challengeStageInfo?.status == "PASSED"
                      ? "var(--blue-opacity)"
                      : challengeStageInfo?.status == "BREACHED"
                      ? "var(--bg-opacity-new)"
                      : challengeStageInfo?.status == "PENDING"
                      ? "var(--yellow-opacity)"
                      : "var(--white)",
                }}
              >
                {challengeStageInfo?.status || "-"}
              </div>
            </div>
          </div>
        )}
        <Separator
          orientation="vertical"
          className="bg-background-opacity w-[0.1rem] rounded-md h-16 opacity-50 md:block hidden"
        />
        <div className="flex  sm:justify-around md:w-[75%]  w-full items-center sm:flex-row  justify-between  2xl:gap-6 sm:gap-2 gap-2 flex-col">
          <div className="flex flex-col gap-1  sm:justify-start justify-center bg-background  p-4 2xl:px-6  px-4 rounded-lg border-2 border-border-darkNew sm:w-1/3 w-full">
            <span className="2xl:text-base text-sm text-white-opacity font-N_Roman sm:justify-start justify-start">
              Today's Permitted Loss
            </span>
            {challengeStageInfoLoading ? (
              <Skeleton className="w-32 h-6 " />
            ) : (
              <div className="xl:text-lg text-base font-N_Bold flex items-center gap-2 sm:justify-start justify-start">
                {challengeStageInfo?.dailyDrawdown
                  ? challengeStageInfo?.dailyDrawdown.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "-"}{" "}
                {challengeStageInfo?.dailyDrawdown && challengeCurrency}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-1  sm:justify-start justify-center bg-background  p-4 2xl:px-6  px-4 rounded-lg border-2 border-border-darkNew sm:w-1/3 w-full">
            <span
              className="2xl:text-base text-sm  text-white-opacity font-N_Roman
            sm:justify-start justify-start"
            >
              Max Permitted Loss
            </span>{" "}
            {challengeStageInfoLoading ? (
              <Skeleton className="w-32 h-6 " />
            ) : (
              <div className="xl:text-lg text-base font-N_Bold flex items-center gap-2 sm:justify-start justify-start">
                {challengeStageInfo?.maxDrawdown
                  ? challengeStageInfo?.maxDrawdown.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "-"}{" "}
                {challengeStageInfo?.maxDrawdown && challengeCurrency}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-1  sm:justify-start justify-center bg-background  p-4 2xl:px-6  px-4 rounded-lg border-2 border-border-darkNew sm:w-1/3 w-full">
            <span className="2xl:text-base text-sm  text-white-opacity font-N_Roman sm:justify-start justify-start">
              Challenge's Profit
            </span>
            {challengeStageInfoLoading ? (
              <Skeleton className="w-32 h-6 " />
            ) : (
              <div
                className="2xl:text-lg text-base font-N_Bold flex items-center gap-2 text-green sm:justify-start justify-start"
                style={{
                  color:
                    challengeStageInfo?.profit + (pl || 0) > 0
                      ? "var(--green)"
                      : challengeStageInfo?.profit + (pl || 0) == 0
                      ? "var(--white)"
                      : "var(--red)",
                }}
              >
                {challengeStageInfo?.profit
                  ? (challengeStageInfo?.profit + (pl || 0)).toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    ) +
                    " " +
                    challengeCurrency
                  : challengeStageInfo?.profit == 0
                  ? "0.00 " + challengeCurrency
                  : "-"}{" "}
              </div>
            )}
          </div>
        </div>
      </div>
      {challengeStageInfo?.Challenge?.Platform?.name == "Trade Locker" ? (
        <CredentialsPopup open={open} setOpen={setOpen} />
      ) : (
        <MT5Credentials open={open} setOpen={setOpen} />
      )}
    </div>
  );
}

export default Header;
